import React, { useState } from 'react';
import '../styles/ModelGridSize.css'
import { data } from './Board.js';
import { restart } from './Board.js';
import { useEffect } from 'react';
import {ImArrowDown, ImArrowUp} from 'react-icons/im'
import ReactGA from 'react-ga4';

ReactGA.initialize('G-7HQ6K7SGK5'); //primal nus latest -GA

function ModelGridSize(props) {
    let importedData;
    const [gridSize, setGridSize] = useState(props.gridSize);

    useEffect(() => {
        console.log("Updated Data....")
        importedData = require('./Board.js').data;
    }, []);

    useEffect(() => {
        console.log("Updating grid size....");
        setGridSize(props.gridSize);
    }, [props.gridSize]);


    const incrementSize = () => {
        // console.log("clicked +")
        // console.log("gridSize : " + gridSize);
        // console.log("data.size : " + data.size );
        data.size = gridSize + 1;
        setGridSize(data.size) ;    
        restart(data.size)   
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Increase Grid Size Button is Clicked'
          });
    }

    const decrementSize = () => {
        // console.log("clicked -")
        // console.log("gridSize : " + gridSize);
        // console.log("data.size : " + data.size );
        data.size = gridSize - 1;
        if(data.size <=1){
            data.size = 1;
        }
        setGridSize(data.size)     
        restart(data.size)
        ReactGA.event({
            category: 'Button',
            action: 'Click',
            label: 'Decrease Grid Size Button is Clicked'
          });
    }

    // useEffect(() => {
    //     document.addEventListener('keydown', handleKeyPress);
    //     return () => {
    //         document.removeEventListener('keydown', handleKeyPress);
    //     };
    // });

    // const handleKeyPress = (event) => {
    //     var name = event.key;

    //     if (name === "ArrowUp") {
    //         restart(gridSize + 1)
    //         setGridSize(gridSize + 1)
    //         //alert('Up Arrow is now Pressed!');
    //     }
    //     if (name === "ArrowDown") {
    //         setGridSize(gridSize - 1)  
    //         if (gridSize < 1) {
    //             restart(1)
    //             setGridSize(1)
    //         }
    //         restart(gridSize)
    //         //alert('Down Arrow is now Pressed!');
    //     }
    // };

    return (
        <div className="gridsize-btn-group">
            {/* <h4 className='model-gridsize-h4'> Grid Size : </h4> */}
            <button className="btn-primary incdec-button"
                onClick={decrementSize}> <ImArrowDown size={15}/>
            </button>
            <button className="btn-primary incdec-button"
                onClick={incrementSize}> <ImArrowUp size={15}/>
            </button>
        </div>
    );
}

export default ModelGridSize;